import { FaIcon, faIdBadge } from '@/lib/fa'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'
import { useEditBusinessTrip } from '../context/EditBusinessTripContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useWrapConfirm } from '@/modules/shared/hooks/useWrapConfirm'
import { useNavigateBackFromEditBusinessTrip } from './editBusinessTripNavigation'
import BusinessTripHeaderFields from '../components/BusinessTripHeaderFields'

const EditBusinessTripHeader = ({
  driverName,
  isDirty,
  companyId,
  formData,
  setFormData,
}: {
  driverName: string | null
  isDirty: boolean
  companyId: string
  formData: any
  setFormData: (updater: any) => void
}) => {
  const { t } = useLocalize()
  const { setExtraViewFalse, isAnyExtraContentOpen } = useEditBusinessTrip()
  const wrapConfirm = useWrapConfirm()
  const handleCancel = useNavigateBackFromEditBusinessTrip()

  const onClose = () => {
    if (isAnyExtraContentOpen) {
      setExtraViewFalse()
    } else {
      isDirty ? handleCancelWrapped() : handleCancel()
    }
  }

  const handleCancelWrapped = wrapConfirm(handleCancel, {
    message: t('configuration.unsaved-changes-close-modal-confirm'),
  })


  const handleCountryChange = (country: any) => {
    setFormData((prev: any) => ({
      ...prev,
      destinationCountry: country,
      country,
    }))
  }

 
  const handleSettlementDateChange = (date: string | null) => {
    setFormData((prev: any) => {
      if (!date) return { ...prev, calculationDate: date }
      const match = date.match(/^(\d{4})-(\d{2})/)
      return {
        ...prev,
        calculationDate: date,
        settlementMonth: match ? `${match[1]}-${match[2]}-01` : date,
      }
    })
  }

  const handleExchangeRateDateChange = (date: string | null) => {
    setFormData((prev: any) => ({ ...prev, exchangeRateDate: date }))
  }

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-rounded-t-lg tw-border-b tw-border-base-300 tw-bg-white tw-px-6 tw-py-4">
      <div className="tw-flex tw-flex-col tw-gap-3">
        <div className="tw-flex tw-items-center tw-gap-2">
          <h1 className="tw-text-xl tw-font-semibold tw-text-content-base">
            {t('businessTrip.edit-delegation')}
          </h1>
          {driverName && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-text-sm">
              <div className="tw-flex tw-items-center tw-gap-1 tw-rounded tw-bg-base-300 tw-px-1">
                <FaIcon icon={faIdBadge} className="tw-cursor-pointer" />
                <span>{driverName}</span>
              </div>
            </div>
          )}
        </div>

        {!isAnyExtraContentOpen && (
          <BusinessTripHeaderFields
            companyId={companyId}
            country={formData?.destinationCountry || formData?.country}
            onCountryChange={handleCountryChange}
            settlementDate={formData?.calculationDate}
            onSettlementDateChange={handleSettlementDateChange}
            exchangeRateDate={formData?.exchangeRateDate}
            onExchangeRateDateChange={handleExchangeRateDateChange}
          />
        )}
      </div>

      {isAnyExtraContentOpen ? (
        <div
          onClick={() => onClose()}
          className="tw-cursor-pointer tw-text-sm tw-text-content-base"
        >
          {t('common.back')}{' '}
        </div>
      ) : (
        <FaIcon
          className="tw-h-5 tw-w-5 tw-shrink-0 tw-cursor-pointer"
          icon={faClose}
          onClick={() => onClose()}
        />
      )}
    </div>
  )
}

export default EditBusinessTripHeader
